import { PropsWithChildren, type JSX } from 'react';

import { Roles } from '@hap/constants'

import { usePermission } from './hooks'

export function WithPermission({
  resource,
  actions,
  children,
}: PropsWithChildren<{
  resource: Roles.ResourceType
  actions: Roles.Permission[]
}>): JSX.Element | null {
  const hasPermission = usePermission({ resource, actions })
  return hasPermission ? <>{children}</> : null
}
